enum SiteStatus {
  INITIAL = 'INITIAL',
  CREATE_REQUEST = 'CREATE_REQUEST',
  CREATE_READY = 'CREATE_READY',
  CREATE_ERROR = 'CREATE_ERROR',
  BUILD_REQUEST = 'BUILD_REQUEST',
  BUILD_READY = 'BUILD_READY',
  BUILD_ERROR = 'BUILD_ERROR',
  READY = 'READY',
}

interface ISiteIds {
  instanceId: string;
  metaSiteId: string;
  siteId?: string;
}

interface ISiteMetaState {
  status: SiteStatus;
  ids?: ISiteIds;
  isCreated: boolean;
  isBuilt: boolean;
  isReady: boolean;
  mediaUploadedToSite: ISiteIds['metaSiteId'][];
}

export { SiteStatus };
export type { ISiteMetaState, ISiteIds };
